module.exports = __webpack_public_path__ + "img/图片5.140d00e9.png";